<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container-fluid" *ngIf="!vm.isOpening">


  <form>
    <cli-landing-header></cli-landing-header>

    <div class="row">
      <div class="col-xl-2 col-lg-1 "></div>
      <div class="col-xl-2 col-lg-2 col-md-3  pt-4">
        <cli-landing-menu></cli-landing-menu>
      </div>
      <div class="col-xl-6 col-lg-8 col-md-9">

        <div class="row  ">
          <div class="col welcome-text ">Hydrotrak New Permit Application</div>
        </div>


        <div class="row section-header">
          <div class="col">Application Details</div>
        </div>


        <div class="row pb-2">
          <div class="col">
            <div class="row mb-1">
              <div class="col-md-6">
                <label>Business Name *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'clientName')}" name="clientName"
                  placeholder="" type="text" [(ngModel)]="vm.clientName">
                <div class="invalid-feedback"> {{error(vm,'clientName')}} </div>
              </div>

              <div class="col-md-6">
                <label>ABN</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'abn')}" name="abn"
                  placeholder="" type="text" [(ngModel)]="vm.abn">
                <div class="invalid-feedback"> {{error(vm,'abn')}} </div>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-md-6">
                <label>First Name *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'firstName')}" name="firstName"
                  placeholder="" type="text" [(ngModel)]="vm.firstName">
                <div class="invalid-feedback"> {{error(vm,'firstName')}} </div>

              </div>

              <div class="col-md-6">
                <label>Last Name *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'lastName')}" name="lastName"
                  placeholder="" type="text" [(ngModel)]="vm.lastName">
                <div class="invalid-feedback"> {{error(vm,'lastName')}} </div>

              </div>
            </div>

            <div class="row mb-1">
              <div class="col-md-6">
                <label>Email *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'email')}" name="email" placeholder=""
                  type="text" [(ngModel)]="vm.email">
                <div class="invalid-feedback"> {{error(vm,'email')}} </div>

              </div>
            </div>

            <div class="row mb-1">
              <div class="col-md-6">
                <label>Work Phone *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'workPhone')}" name="workPhone"
                  placeholder="e.g. (03) 5555 1234" type="text" [(ngModel)]="vm.workPhone" (keyup)="formatPhone('workPhone')"
                  >
                <div class="invalid-feedback"> {{error(vm,'workPhone')}} </div>

              </div>
              <div class="col-md-6">
                <label>Mobile Phone *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'mobilePhone')}" name="mobilePhone"
                placeholder="e.g. 0455 355 355" type="text" [(ngModel)]="vm.mobilePhone" (keyup)="formatPhone('mobilePhone')">
                <div class="invalid-feedback"> {{error(vm,'mobilePhone')}} </div>

              </div>
            </div>

            <div class="row  mb-1 ">
              <div class="col-md-6">
                <label>Type of Business *</label>
                <select class="form-control" [ngClass]="{'is-invalid': !!error(vm,'businessTypeId')}"
                  name="businessTypeId" [(ngModel)]="vm.businessTypeId">
                  <option [ngValue]="0"></option>
                  <option *ngFor="let c of vm.businessTypes" [ngValue]="c.businessTypeId">
                    {{c.description}}</option>
                </select>
                <div class="invalid-feedback"> {{error(vm,'businessTypeId')}} </div>
              </div>

              <div class="col-md-6"
                *ngIf="vm.businessTypeId && vm.businessTypeId.toUpperCase() == '59BA4193-9F7B-48DE-B2C1-B7BD7D2D5AD1'">
                <label>Business Description *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm, 'businessTypeOther')}"
                  name="businessTypeOther" [(ngModel)]="vm.businessTypeOther">
                <div class="invalid-feedback"> {{error(vm, 'businessTypeOther')}} </div>
              </div>

            </div>

            <div class="row pt-4">
              <div class="col">
                <h6 class="font-weight-bold">Business Address</h6>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <label>Search Address</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'addressSearch')}" name="addressSearch"
                  placeholder="Start typing your business address here" type="text" [(ngModel)]="vm.addressSearch"                   
                  [disabled]="vm.isAddressNotFound"
                  ngx-google-places-autocomplete (onAddressChange)="handleAddressChange($event)"
                  [options]="googlePlacesOptions">
                <div class="invalid-feedback"> {{error(vm,'addressSearch')}} </div>

              </div>
            </div>

            <div class="row pb-2 pt-2">
              <div class="col">
                <div class="form-check">
                  <input style="cursor:pointer;" class="form-check-input" name="isAddressNotFound" type="checkbox" value="true"
                  (change)="addressNotFoundChanged()"  
                    id="isAddressNotFound" [(ngModel)]="vm.isAddressNotFound" [ngClass]="{'is-invalid': !!error(vm,'isAddressNotFound')}">
                  <span>I cannot find my business address</span>
                </div>                
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <label>Address Line 1 *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'address1')}" name="address1"
                  placeholder="" type="text" [(ngModel)]="vm.address1" (change)='updateBillingAddress()'
                  [readonly]="!vm.isAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'address1')}} </div>

              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <label>Address Line 2 </label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'address2')}" name="address2"
                  placeholder="" type="text" [(ngModel)]="vm.address2" (change)='updateBillingAddress()'
                  [readonly]="!vm.isAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'address2')}} </div>

              </div>
            </div>

            <div class="row  mb-1">
              <div class="col-md-6">
                <label>Suburb *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'suburb')}" name="suburb"
                  placeholder="" type="text" [(ngModel)]="vm.suburb" (change)='updateBillingAddress()'
                  [readonly]="!vm.isAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'suburb')}} </div>

              </div>

              <div class="col-md-2">
                <label>State *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'state')}" name="state" placeholder=""
                  type="text" [(ngModel)]="vm.state" (change)='updateBillingAddress()'
                  [readonly]="!vm.isAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'state')}} </div>

              </div>

              <div class="col-md-4">
                <label>Postcode *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'postCode')}" name="postCode"
                  placeholder="" type="text" [(ngModel)]="vm.postCode" (change)='updateBillingAddress()'
                  [readonly]="!vm.isAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'postCode')}} </div>

              </div>
            </div>


            <div class="row pt-4">
              <div class="col">
                <h6 class="font-weight-bold">Billing Address</h6>
              </div>
            </div>


            <div class="row pb-1">
              <div class="col-md-6">
                <label>Is Billing Address same as Business Address?</label>

                <div>
                  <div class="form-check-inline">
                    <input class="form-check-input" type="radio" (click)="copyBusinessAddress()" name="isSameAddress1"
                      id="isSameAddress1" style="cursor:pointer;" [value]="true" [(ngModel)]="vm.isSameAddress">
                    <span>Yes</span>

                  </div>
                  <div class="form-check-inline">
                    <input class="form-check-input" type="radio" (click)="clearBillingAddress()" name="isSameAddress2"
                      id="isSameAddress2" style="cursor:pointer;" [value]="false" [(ngModel)]="vm.isSameAddress">
                    <span>No</span>

                  </div>
                </div>
              </div>
            </div>


            <div class="row mb-1"  [hidden]="vm.isSameAddress">
              <div class="col">
                <label>Search Address</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingAddressSearch')}" name="billingAddressSearch"
                  placeholder="Start typing your billing address here" type="text" [(ngModel)]="vm.billingAddressSearch" 
                  ngx-google-places-autocomplete (onAddressChange)="handleBillingAddressChange($event)"  
                  [options]="googlePlacesOptions"                
                  [readonly]="vm.isSameAddress || (!vm.isSameAddress && vm.isBillingAddressNotFound)">
                <div class="invalid-feedback"> {{error(vm,'billingAddressSearch')}} </div>

              </div>
            </div>

            <div class="row pb-2 pt-2" [hidden]="vm.isSameAddress">
              <div class="col">
                <div class="form-check">
                  <input style="cursor:pointer;" class="form-check-input" name="isBillingAddressNotFound" type="checkbox" value="true"
                  (change)="billingAddressNotFoundChanged()"                  
                    id="isBillingAddressNotFound" [(ngModel)]="vm.isBillingAddressNotFound" [ngClass]="{'is-invalid': !!error(vm,'isBillingAddressNotFound')}"
                    [disabled]="vm.isSameAddress">
                  <span>I cannot find my billing address</span>
                </div>                
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <label>Address Line 1 *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingAddress1')}"
                  name="billingAddress1" placeholder="" type="text" [(ngModel)]="vm.billingAddress1"
                  [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'billingAddress1')}} </div>

              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <label>Address Line 2 </label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingAddress2')}"
                  name="billingAddress2" placeholder="" type="text" [(ngModel)]="vm.billingAddress2"
                  [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'billingAddress2')}} </div>
              </div>
            </div>

            <div class="row  mb-1">
              <div class="col-md-6">
                <label>Suburb *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingSuburb')}" name="billingSuburb"
                  placeholder="" type="text" [(ngModel)]="vm.billingSuburb" [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'billingSuburb')}} </div>
              </div>

              <div class="col-md-2">
                <label>State *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingState')}" name="billingState"
                  placeholder="" type="text" [(ngModel)]="vm.billingState" [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'billingState')}} </div>

              </div>

              <div class="col-md-4">
                <label>Postcode *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'billingPostCode')}"
                  name="billingPostCode" placeholder="" type="text" [(ngModel)]="vm.billingPostCode "
                  [readonly]="vm.isSameAddress || !vm.isBillingAddressNotFound">
                <div class="invalid-feedback"> {{error(vm,'billingPostCode')}} </div>

              </div>
            </div>
          </div>
        </div>


        <div class="row section-header mt-4">
          <div class="col">Vehicles</div>
        </div>

        <div>
          <hr class="mt-0" />
        </div>

        <div class="row">
          <div class="col">

            <div class="row">
              <div class="col">
                <h6 class="font-weight-bold">Pricing Information</h6>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-6">
                <label>Price per Vehicle</label>
                <h6 class="pt-1">{{vm.permitFee | currency:false:'symbol':'0.2' }}</h6>
              </div>

              <div class="col-md-6 ">
                <label>Water Rate per kL</label>
                <h6 class="pt-1">{{vm.usageFee | currency:false:'symbol':'0.4' }}</h6>
              </div>
            </div>

            <hr class="mb-4 mt-0">

            <ng-container *ngFor="let v of vm.vehicles; let i = index">

              <div class="row">
                <div class="col">
                  <h6 class="font-weight-bold">Vehicle <span *ngIf="vm.vehicles.length>1">{{i+1}}</span></h6>
                </div>
              </div>

              <div class="row pb-1">
                <div class="col-md-6">
                  <label>Registration No *</label>
                  <input class="form-control" [ngClass]="{'is-invalid': !!error(v,'regoNo')}"
                    [name]="'regoNo' + v.vehicleId" placeholder="" type="text" [(ngModel)]="v.regoNo"
                    (keyup)="onRegoChanged($event, v)" (paste)="onRegoChanged($event, v)">
                  <div class="invalid-feedback"> {{error(v,'regoNo')}} </div>

                </div>
                <div class="col-md-3">
                  <label>State *</label>
                  <input class="form-control" [ngClass]="{'is-invalid': !!error(v,'state')}"
                    [name]="'state' + v.vehicleId" placeholder="" type="text" [(ngModel)]="v.state"
                    (keyup)="onRegoChanged($event, v)" (paste)="onRegoChanged($event, v)">
                  <div class="invalid-feedback"> {{error(v, 'state')}} </div>

                </div>
                <div class="col-md-3">
                  <label>Capacity, Litres*</label>
                  <input class="form-control" [ngClass]="{'is-invalid': !!error(v,'capacity')}"
                    [name]="'capacity' + v.vehicleId" placeholder="" type="text" [(ngModel)]="v.capacity">
                  <div class="invalid-feedback"> {{error(v, 'capacity')}} </div>

                </div>
              </div>

              <div class="row pb-1">
                <div class="col-md-6">
                  <label>Vehicle Type *</label>

                  <select class=" form-control" [ngClass]="{'is-invalid': !!error(v,'vehicleTypeId')}"
                    [name]="'vehicleTypeId' + v.vehicleId" [(ngModel)]="v.vehicleTypeId">
                    <option [ngValue]="0"></option>
                    <option *ngFor="let c of vm.vehicleTypes" [ngValue]="c.vehicleTypeId">
                      {{c.description}}</option>
                  </select>
                  <div class="invalid-feedback"> {{error(v,'vehicleTypeId')}} </div>

                </div>

                <div class="col-md-6">
                  <label>Vehicle Make *</label>
                  <select class="form-control" [ngClass]="{'is-invalid': !!error(v,'vehicleMakeId')}"
                    [name]="'vehicleMakeId' + v.vehicleId" [(ngModel)]="v.vehicleMakeId">
                    <option [ngValue]="0"></option>
                    <option *ngFor="let c of vm.vehicleMakes" [ngValue]="c.vehicleMakeId">
                      {{c.description}}</option>
                  </select>
                  <div class="invalid-feedback"> {{error(v,'vehicleMakeId')}} </div>

                </div>
              </div>
              <div class="row pb-1">
                <div class="col-md-6">
                  <label>Is this vehicle fitted with backflow prevention device?&nbsp;<i class="fas fa-question-circle"
                      style="color:#0088BB; font-size:1rem; cursor:pointer;" (click)="showBackflowToolTip()"></i></label>

                  <div>
                    <div class="form-check-inline">

                      <input class="form-check-input" type="radio"
                        [name]="'isBackflowPreventionDeviceSetup' + v.vehicleId" id="isBackflowPreventionDeviceSetup1"
                        style="cursor:pointer;" [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceSetup')}"
                        [value]="true" [(ngModel)]="v.isBackflowPreventionDeviceSetup">
                      <span>Yes</span>

                    </div>
                    <div class="form-check-inline">
                      <input class="form-check-input" type="radio" (click)="clearDevices(v)"
                        [name]="'isBackflowPreventionDeviceSetup' + v.vehicleId" id="isBackflowPreventionDeviceSetup2"
                        style="cursor:pointer;" [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceSetup')}"
                        [value]="false" [(ngModel)]="v.isBackflowPreventionDeviceSetup">
                      <span>No</span>
                    </div>

                  </div>
                  <div>
                    <input class="form-check-input" type="hidden"
                      [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceSetup')}">
                    <div class="invalid-feedback">{{error(v,'isBackflowPreventionDeviceSetup')}}</div>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="v.isBackflowPreventionDeviceSetup">
                  <label>Type of backflow prevention device </label>

                  <div>
                    <div class=" form-check">
                      <input [disabled]="!v.isBackflowPreventionDeviceSetup" style="cursor:pointer;"
                        class="form-check-input" [name]="'isRPZD' + v.vehicleId" type="checkbox" [value]="true"
                        [(ngModel)]="v.isRPZD">
                      <span>Reduced pressure zone device</span>
                    </div>

                    <div class="form-check">
                      <input [disabled]="!v.isBackflowPreventionDeviceSetup" style="cursor:pointer;"
                        class="form-check-input" [name]="'isAirGap' + v.vehicleId" type="checkbox" [value]="true"
                        [(ngModel)]="v.isAirGap">
                      <span>Air gap</span>
                    </div>

                    <div>
                      <input class="form-check-input" type="hidden"
                        [ngClass]="{'is-invalid': !!error(v,'backflowDeviceType')}">
                      <div class="invalid-feedback">{{error(v,'backflowDeviceType')}}</div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row pb-1" *ngIf="v.isBackflowPreventionDeviceSetup">
                <div class="col-md-6">
                  <label>Is the backflow prevention device tested and certified?</label>

                  <div>
                    <div class="form-check-inline">
                      <input class="form-check-input" type="radio"
                        [name]="'isBackflowPreventionDeviceCertified' + v.vehicleId"
                        id="isBackflowPreventionDeviceCertified1" style="cursor:pointer;"
                        [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceCertified')}" [value]="true"
                        [(ngModel)]="v.isBackflowPreventionDeviceCertified">
                      <span>Yes</span>

                    </div>
                    <div class="form-check-inline">
                      <input class="form-check-input" type="radio" (click)="clearCerficate(v)"
                        [name]="'isBackflowPreventionDeviceCertified' + v.vehicleId"
                        id="isBackflowPreventionDeviceCertified2" style="cursor:pointer;"
                        [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceCertified')}" [value]="false"
                        [(ngModel)]="v.isBackflowPreventionDeviceCertified">
                      <span>No</span>
                    </div>

                  </div>
                  <div>
                    <input class="form-check-input" type="hidden"
                      [ngClass]="{'is-invalid': !!error(v,'isBackflowPreventionDeviceCertified')}">
                    <div class="invalid-feedback">{{error(v,'isBackflowPreventionDeviceCertified')}}</div>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="v.isBackflowPreventionDeviceCertified">
                  <label>Certificate issue date</label>
                  <input class="form-control"
                    [ngClass]="{'is-invalid': !!error(v,'backflowPreventionCertificateIssueDate')}"
                    [name]="'backflowPreventionCertificateIssueDate' + v.vehicleId" placeholder="dd/mm/yyyy" type="text"
                    [(ngModel)]="v.backflowPreventionCertificateIssueDate" ngbDatepicker #dExpiryDate="ngbDatepicker"
                    (click)="dExpiryDate.toggle()">
                  <div class="invalid-feedback"> {{error(v,'backflowPreventionCertificateIssueDate')}} </div>
                </div>
              </div>
              <div class="row pb-1 pt-2"
                *ngIf="v.isBackflowPreventionDeviceSetup && v.isBackflowPreventionDeviceCertified">
                <div class="col-md-6">
                  <label>Attach a copy of certificate</label>
                  <div>
                    <cli-file-upload [maxCount]="1" [allowComments]="false" [objectId]="v.vehicleId"
                      [objectType]="'Vehicle'" [fileList]="v.fileList">
                    </cli-file-upload>
                  </div>
                  <div>
                    <input class="form-check-input" type="hidden"
                      [ngClass]="{'is-invalid': !!error(v,'uploadCertificate')}">
                    <div class="invalid-feedback">{{error(v,'uploadCertificate')}}</div>
                  </div>
                </div>
              </div>
              <div class="row pb-1" *ngIf="v.isBackflowPreventionDeviceSetup === false || v.isBackflowPreventionDeviceCertified === false">
                <div class="col pt-2">
                  <div class="alert alert-danger">
                    <strong>Important</strong>
                    <p>
                      A backflow prevention device is required to be installed and certified on this vehicle.
                      <br/><br/>
                      You will not be able to submit a Hydrotrak application to South East Water until you provide us with your certificate.
                    </p>
                  </div>
                </div>
              </div>
             
              <hr class="mb-2 vehicle-separator">

            </ng-container>

            <div class="row mb-2 ">
              <div class="col d-flex justify-content-end">
                <div class="pr-2"><button class="btn btn-sm btn-link" (click)="addNewVehicle()">Add Vehicle</button>
                </div>
                <div class="pr-2" *ngIf="vm.vehicles.length>1"><button class="btn btn-sm btn-link"
                    (click)="removeVehicle()">Remove Vehicle</button></div>
              </div>
            </div>
          </div>
        </div>


        <div class="row section-header mt-4">
          <div class="col">Permit Details</div>
        </div>

        <div>
          <hr class="mt-0" />
        </div>

        <div class="row pb-4">
          <div class="col">

            <div class="row  pb-1 ">
              <div class="col-md-6">
                <label>Start Date *</label>
                <input class="form-control" [ngClass]="{'is-invalid': !!error(vm,'startDate')}" name="startDate"
                  [(ngModel)]="vm.startDate" placeholder="dd/mm/yyyy" type="text" ngbDatepicker
                  #dremoveDate="ngbDatepicker" (click)="dremoveDate.toggle()" autocomplete="false">
                <div class="invalid-feedback"> {{error(vm,'startDate')}} </div>
              </div>

              <div class="col-md-6 ">
                <label>Total Annual Permit Cost</label>
                <h6 class="pt-2">{{vm.totalCost | currency:false:'symbol':'0.2' }}</h6>
              </div>
            </div>


            <div class="row pb-1">
              <div class="col-md-6">
                <label>Do you require an EMS key?&nbsp;<i class="fas fa-question-circle"
                  style="color:#0088BB; font-size:1rem; cursor:pointer;" (click)="showEmsToolTip()"></i></label>

                <div>
                  <div class="form-check-inline">
                    <input class="form-check-input" type="radio" name="isEmsKey" id="isEmsKey1" style="cursor:pointer;"
                      [ngClass]="{'is-invalid': !!error(vm,'isEmsKey')}" [value]="true" [(ngModel)]="vm.isEmsKey">
                    <span>Yes</span>

                  </div>
                  <div class="form-check-inline">
                    <input class="form-check-input" type="radio" name="isEmsKey" id="isEmsKey2" style="cursor:pointer;"
                      [ngClass]="{'is-invalid': !!error(vm,'isEmsKey')}" [value]="false" [(ngModel)]="vm.isEmsKey">
                    <span>No</span>

                  </div>

                </div>
                <div>
                  <input class="form-check-input" type="hidden" [ngClass]="{'is-invalid': !!error(vm,'isEmsKey')}">
                  <div class="invalid-feedback">{{error(vm,'isEmsKey')}}</div>
                </div>
              </div>

            </div>

            <div class="row pb-2 pt-4">
              <div class="col">
                <div class="form-check">
                  <input style="cursor:pointer;" class="form-check-input" name="isTCRead" type="checkbox" value="true"
                    id="isTCRead" [(ngModel)]="vm.isTCRead" [ngClass]="{'is-invalid': !!error(vm,'isTCRead')}">
                  <span>I have read and accept <a href="assets/HydrotrakConditionsofPermit.pdf" target="_blank">Terms and
                      Conditions</a> and <a href="assets/HydrotrakPortalTC.pdf" target="_blank">Terms of Use</a></span>
                </div>
                <div>
                  <input class="form-check-input" type="hidden" [ngClass]="{'is-invalid': !!error(vm,'isTCRead')}">
                  <div class="invalid-feedback">{{error(vm,'isTCRead')}}</div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                  <input class="form-check-input" type="hidden"
                    [ngClass]="{'is-invalid': hasErrors()}">
                  <div class="invalid-feedback"><h5><i class="fas fa-exclamation-triangle"></i> The form contains errors, please review errors and try again</h5></div>
              </div>
            </div>

          </div>
        </div>

        <div class="row pb-4 ">
          <div class="col-md-6">
            <button class="btn btn-primary" type="button" (click)="submit()">Submit Application</button>
          </div>
        </div>


      </div>
      <div class="col-xl-2 col-lg-1"></div>
    </div>

    <cli-landing-footer></cli-landing-footer>
  </form>
</div>
<cli-terms-and-conditions-modal #tcModal [id]="'tcModal'"></cli-terms-and-conditions-modal>
<cli-backflow-tooltip-modal #backflowTooltipModal [id]="'backflowTooltipModal'"></cli-backflow-tooltip-modal>
<cli-ems-tooltip-modal #emsTooltipModal [id]="'emsTooltipModal'"></cli-ems-tooltip-modal>
<cli-vehicle-exists-warning-modal #vehicleExistsWarningModal [id]="'vehicleExistsWarningModal'"></cli-vehicle-exists-warning-modal>
